// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"865352c5","703":"a4320fec","787":"a67df2b7"}[chunkId] + ".chunk.js";
};